import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";

var isFancyboxOpen = false;
$(".rollover").hide();
$(".rim").hover(
	function () {
		if ($(".open").length != 0) {
			closeDetails($(".open"));
		}
		openDetails($(this));
	}, function () {
		if (!isFancyboxOpen) {
			closeDetails($(this));
		}
	}
);

Fancybox.bind(".openBigRimImage", {
	on: {
		reveal: () => { isFancyboxOpen = true; },
		closing: () => { isFancyboxOpen = false; },
	}
});

$(".rimSizes").each(function () {
	if ($(this).children().length > 4) {
		$(this).children().slice(4).hide();

		var button = $('<a class="showAllRimSizes button is-small">Alle anzeigen<span class="sliding"/></a>');
		button.data('associatedContainer', this);
		$(this).append(button);
	}
});

$(".showAllRimSizes").click(function () {
	if ($(this).data("state") == "closed") {
		var container = $(this).data('associatedContainer');
		$(container).children().not(".button").slice(4).hide();
		$(this).html('› alle anzeigen<span class="sliding"/>');

		$(this).data("state", "open");
	} else {
		var container = $(this).data('associatedContainer');
		$(container).children().show();
		$(this).html('^ verstecken<span class="sliding"/>');

		$(this).data("state", "closed");
	}
});

$("#backToTopAction").click(function () {
	$("html, body").animate({
		scrollTop: 0
	}, 700);
});

function openDetails(element: JQuery) {
	if ($(window).width()! >= 768) {
		element.toggleClass('open');
		element.find(".image").css('z-index', 400);
		element.find(".rollover").fadeIn('fast');
	}
}
function closeDetails(element: JQuery) {
	if ($(window).width()! >= 768) {
		element.find(".image").css('z-index', 0);
		element.find(".rollover").hide('fast');
		element.toggleClass('open');
	}
}
